<template>
    <v-container
            fluid
    >
        <v-row
                align="center"
                justify="center"
                class="text-center">
            <v-col
                    cols="12"
                    sm="6"
            >
                <v-img
                        class="ml-4 mr-4"
                        :src="language === 'es' ? require('../../assets/residencial_mx.png') : require('../../assets/residencial_eu.png')"
                        height="250px"
                        contain
                ></v-img>
                <br>
                <h3>{{$t('msg_helpus_safeguard_account')}}</h3>
                <p>{{$t('opt_security_msg_01')}} {{$t('opt_security_msg_02')}}</p>
                <v-form
                        class="mb-4"
                        @submit.prevent="checkOTP()">
                    <v-flex sm12>
                        <v-text-field
                                v-model="otp"
                                prepend-icon="mdi-key"
                                name="otp"
                                :label="$t('verification_code')"
                                :error-messages="errores.otp"
                                maxlength="6"
                                outlined
                        >
                        </v-text-field>
                    </v-flex>
                    <v-btn
                        block
                        color="primary"
                        type="submit"
                        :loading="loading">
                        {{$t('verify_code')}}
                    </v-btn>
                    <v-spacer></v-spacer><br>
                    <v-btn
                        text
                        block
                        @click="resendOTP"
                        color="primary"
                        :loading="loadingResendOTP">
                        {{$t('resend_code_email')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        block
                        @click="resendOTPByWhatsapp"
                        color="primary"
                        :loading="loadingResendOTPWhatsapp">
                        {{$t('resend_code_whatsapp')}}
                    </v-btn>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import store from '@/store'

export default {
  name: 'reset_password',
  data: () => ({
    otp: '',
    errores: [],
    loading: false,
    loadingResendOTP: false,
    loadingResendOTPWhatsapp: false
  }),
  computed: {
    ...mapState(['language'])
  },
  methods: {
    checkOTP: function () {
      this.loading = true
      this.errores = []
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/users/check_otp',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken,
          'Accept-Language': this.language
        },
        data: {
          otp: this.otp
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          localStorage.setItem('enable_2fa', this.otp)
          this.$router.push({ path: '/home' })
          this.$store.commit('changeOTP', true)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    resendOTP: function () {
      this.loadingResendOTP = true
      this.errores = []
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/users/resend_otp',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(ok => {
          this.loadingResendOTP = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('opt_resend_msg'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingResendOTP = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    resendOTPByWhatsapp () {
      this.loadingResendOTPWhatsapp = true
      this.errores = []
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/users/resend_otp_whatsapp',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(ok => {
          this.loadingResendOTPWhatsapp = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('opt_resend_msg'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingResendOTPWhatsapp = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>

</style>
